<template>
  <div class="wownow-launch" @click="launchClick" :style="btnStyle">
    <slot />
    <wx-open-launch-app v-if="appid" class="launch-btn"  :id="comId" :appid="appid" :extinfo="extinfoProps">
      <script type="text/wxtag-template">
        <style>
          .wechat-btn-to-wownowasdfasdfads {
            border: 0 none;
            background-color: transparent;
            border-color: transparent;
            outline: none;
            z-index: 999;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
          }
          .wechat-btn-to-wownowasdfasdfads:active, .wechat-btn-to-wownowasdfasdfads:hover, .wechat-btn-to-wownowasdfasdfads:link, .wechat-btn-to-wownowasdfasdfads:visited {
            width: 100%;
            border: 0 none;
            box-shadow: none;
            outline: none;
            border-color: transparent;
          }
        </style>
        <button class="wechat-btn-to-wownowasdfasdfads"></button>
      </script>
    </wx-open-launch-app>
  </div>
</template>
<script>
export default {
  props: {
    appid: {
      type: String,
      default: () => ''
    },
    width: {
      type: [Number, String],
      default: () => '100%'
    },
    height: {
      type: [Number, String],
      default: () => '100%'
    },
     left: {
      type: [Number, String],
      default: () => 0
    },
    bottom: {
      type: [Number, String],
      default: () => 0
    },
    position: {
      type: [Number, String],
      default: () =>'relative'
    },
    extinfoProps: {
      type: String,
      default: () => ''
    },
    comId: {
      type: [Number, String],
      default: 'launch-btn'
    }
  },
  data() {
    return {
      wechatBtn: undefined,
      isShow: this.appid,
      style: {
        left: 0,
        bottom: 0,
      }
    };
  },
   watch: {
  },
  computed: {
    btnStyle() {
      let pxArr =  Object.keys(this.style).map(e => `${e}: ${this.style[e]}px`)
      let positionArr = `position:${this.position}`
      this.position && pxArr.push(positionArr)
      let str = pxArr.join(';')
      return str
    }
  },
  mounted() {
    this.$set(this.style,'left',this.left)
    this.$set(this.style,'width',this.width)
    this.$set(this.style,'height',this.height)
    this.$set(this.style,'bottom',this.bottom)
    
    this.$nextTick(() => {
      new Promise((resolve, reject) => {
        this.wechatBtn = document.getElementById(this.comId);
        this.wechatBtn && this.wechatBtn.addEventListener('launch', e => resolve(e));
        this.wechatBtn && this.wechatBtn.addEventListener('error', e => reject(e));
      }).then(res => {
        aler('success')
        this.$emit('launch-success')
        }).catch(e => {
        console.log('launch-error: ', e);
        this.$emit('launch-error', e);
      }).finally(() => {
        console.log('launch-finally')
        this.timeout(() => {
          // this?.wechatBtn?.remove();
          // this.isShow = false;
        }, 10);
      });
    });
  },
  methods: {
    launchClick() {
      this.$emit('click');
    },
    timeout(fn, time = 0) {
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        typeof fn === 'function' && fn();
      }, time);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .wownow-launch {
    position: relative;
    z-index: 998;
  }
 
</style>
<style lang="stylus">
 .launch-btn {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
</style>

